import {useSchedulersHandling} from "../../hooks/schedulers/useSchedulersHandling";
import Layout from "../../components/Layout";
import {capitalize, DialogActions, DialogContent, Paper, Typography} from "@mui/material";
import {schedulersStyles} from "../../styles/schedulers/schedulers.styles";
import {Form, Formik, FormikProps} from "formik";
import FieldsContentScheduler from "../../components/schedulers/FieldsContentScheduler";
import SubmitButton from "../../components/SubmitButton";
import {useSchedulerCreateForm} from "../../hooks/schedulers/useSchedulerCreateForm";
import ErrorAlert from "../../components/ErrorAlert";
import {notPermitted} from "../../errors";
import {permissions} from "../../permissions";
import MultipleGuard from "../../components/guards/MultipleGuard";
import type {SchedulerFormValues} from "../../types/schedulerTypes";

export default function PageCreateScheduler() {
    const {translation} = useSchedulersHandling();
    const formikProps = useSchedulerCreateForm();

    return (
        <Layout
            title={capitalize(translation('scheduler-create'))}
            back={"/schedulers"}
        >
            <MultipleGuard
                permissions={[
                    permissions.schedulers.create,
                    permissions.schedulers.own_create,
                ]}
                fallback={<ErrorAlert error={notPermitted()}/>}
            >
                <Paper id={'page-create-scheduler-paper'}
                       elevation={1}
                       sx={schedulersStyles.pageCreateScheduler.paper}
                >
                    <Formik {...formikProps}>
                        {({isSubmitting, isValidating, isValid, dirty}: FormikProps<SchedulerFormValues>) => (
                            <Form id={'form-create-scheduler'}>
                                <Typography variant="h5">
                                    {capitalize(translation('scheduler-create'))}
                                </Typography>
                                <DialogContent id={'page-create-scheduler-dialog-content'}>
                                    <FieldsContentScheduler canEditFields={true}/>
                                </DialogContent>
                                <DialogActions id={'page-create-scheduler-dialog-actions'}>
                                    <SubmitButton id={'page-create-scheduler-submit-button'}
                                                  form={'form-create-scheduler'}
                                                  type={'submit'}
                                                  variant={'contained'}
                                                  color={'secondary'}
                                                  loading={isSubmitting}
                                                  disabled={isValidating || !isValid || !dirty}
                                    >
                                        {isSubmitting ? capitalize(translation('creating')) : capitalize(translation('create'))}
                                    </SubmitButton>
                                </DialogActions>
                            </Form>
                        )}
                    </Formik>
                </Paper>
            </MultipleGuard>
        </Layout>
    );
}
